export default function toFixed(n, m = 2) {
  if (typeof n === 'number') {
    if (Object.is(n, -0) || !isFinite(n)) return toFixed(0, m)
    let t = n.toFixed(m)
    if (t[0] === '0' && t[1] === '.') {
      t = t.slice(1)
    } else if (t[0] === '-' && t[1] === '0' && t[2] === '.') {
      t = '-' + t.slice(2)
    }
    if (t === '.0') {
      t = '0'
    }
    return t
  } else if (typeof n === 'string') {
    return toFixed(parseFloat(n), m)
  } else {
    return ''
  }
}
